import { Component, Input, OnInit } from '@angular/core';
import { IProduct, IProductCatalog, IProductCatalogsData } from '../../../models/products.models';
import { AppState } from 'src/app/core/app.state';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { ActivatedRoute, Router } from '@angular/router';
import { SetCurrentElementId } from 'src/app/shared/store/shared.actions';
import {
  GetProductById,
  GetProductByIdError,
  GetProductByIdSuccess,
  GetProductCatalogs,
  GetProductCatalogsError,
  GetProductCatalogsSuccess,
} from '../../../store/produits.actions';
import { Observable, Subscription, tap } from 'rxjs';
import { DATE_FORMAT } from 'src/app/config/global.config';
import { environment } from 'src/environments/environment';
import { IVariantElement } from '../insights/insights.component';
import { FormControl } from '@angular/forms';
import { IPriceBookSimple, PriceBookTypeValue } from 'src/app/features/pricebook/models/pricebook.model';
import { PricebookService } from 'src/app/features/pricebook/services/pricebook.service';
import { FeatureFlagService } from 'src/app/core/services/feature-flag.service';
import { StatusBadgeTone } from 'src/app/ui/status-badge/status-badge.component';

@Component({
  selector: 'app-catalogs',
  templateUrl: './catalogs.component.html',
  styleUrls: ['./catalogs.component.scss']
})
export class CatalogsComponent implements OnInit {
  @Input() product!: IProduct;
  private subscriptions: Subscription[] = [];
  productCatalogs$: Observable<IProductCatalogsData | null> = this.store.select((state)=> state.products.productCatalogs);
  productCatalogsData: IProductCatalogsData | null = null;
  productCatalogs: IProductCatalog[] = [];
  productPricingRules: IPriceBookSimple[] = [];
  productPromotions: IPriceBookSimple[] = [];
  variants: IVariantElement[] = [];
  variantControl = new FormControl('all_variants');
  DATE_FORMAT = DATE_FORMAT;
  baseUrl = environment.BASE_URL_API;
  timestamp = new Date().getTime();
  failedImages = new Set<string>();

  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private router: Router,
    private pricebookService: PricebookService,
    public featureFlags: FeatureFlagService,
  ) { }

  ngOnInit(): void {
      if (this.product) {
        this.store.dispatch(
          SetCurrentElementId({ currentElementId: this.product.id })
        );
        this.store.dispatch(GetProductCatalogs({ id: this.product.id}));
      }

      const sub3 = this.productCatalogs$.subscribe((catalogs) => {
        if (catalogs) {
          this.productCatalogsData = catalogs;
          this.productCatalogs = catalogs.catalogs;
          this.productPricingRules = catalogs.pricing_rules;
          this.productPromotions = catalogs.promotions;
          this.variants = catalogs.variants;
        }
      });

      const sub4 = this.actions$
      .pipe(
        ofType(
          GetProductCatalogsError
        ),
        tap(() => {
          // this.cancel(true);
        })
      )
      .subscribe();

    this.variantControl.valueChanges.subscribe((value) => {
      if(value === 'all_variants'){
        this.productCatalogs = this.productCatalogsData!.catalogs;
        this.productPricingRules = this.productCatalogsData!.pricing_rules;
          this.productPromotions = this.productCatalogsData!.promotions;
      } else {
        const variantId = typeof value === 'string' ? parseInt(value, 10) : value;
        this.productCatalogs = this.productCatalogsData!.variants.find(variant => variant.variant_id === variantId)?.catalogs ?? [];
        this.productPricingRules = this.productCatalogsData!.variants.find(variant => variant.variant_id === variantId)?.pricing_rules ?? [];
        this.productPromotions = this.productCatalogsData!.variants.find(variant => variant.variant_id === variantId)?.promotions ?? [];
      }
    });

    this.subscriptions.push(sub3, sub4);
  }

  getPricebookCalculationTypeDisplayText(type: PriceBookTypeValue) {
    return this.pricebookService.getPricebookCalculationTypeDisplayText(type) ?? '--';
  }

  cancel(keepParams = true) {
    this.router.navigate(['inventory'], {
      queryParamsHandling: keepParams ? 'merge': ''
    });
  }

  getImage(image: string): string {
    return this.baseUrl + image + '?thumbnail=1&timestamp=' + this.timestamp;
  }

  onImageError(imageUrl: string): void {
    this.failedImages.add(imageUrl); // Mark this image as failed
  }

  /**
   * Catalog membership status → badge tone. Approved reads as live (same green
   * as a Published product), Inactive as blocked, anything else as pending.
   */
  catalogStatusTone(status?: string | null): StatusBadgeTone {
    switch ((status ?? '').trim().toLowerCase()) {
      case 'approved':
        return 'success';
      case 'inactive':
        return 'destructive';
      default:
        return 'draft';
    }
  }

  catalogTypeIcon(type: string): string {
    switch(type){
      case 'agent':
        return 'assets/icones/briefcase.svg';
      case 'client':
        return 'assets/icones/companies.svg';
      default:
        return '';
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

}
